import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import ServicesContent from '../components/ServicesContent'; 
 import axios from 'axios';
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader';  
import ExploreMore from '../components/ExploreMore'; 
import GetInTouch from '../components/GetInTouch'; 
import { Helmet } from "react-helmet";
import { api_base_url, base_url} from '../common/Constants';

import withRouter from '../components/withRouter';
import AOS from "aos";
 
class Services extends React.Component{
   constructor(props){
           super(props);
   
           
           this.state = {
               service : [],
               loading : 1 
           }
       }

       componentDidMount() {
    const data = { id: this.props.params.id };

    axios.post(api_base_url + "service", data).then((response) => {
      this.setState(
        {
          service: response.data,
          loading: 0,
        },
        () => {
          AOS.refreshHard();
        }
      );
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.params.id !== prevProps.params.id) {
      const data = { id: this.props.params.id };

      axios.post(api_base_url + "service", data).then((response) => {
        this.setState(
          {
            service: response.data,
            loading: 0,
          },
          () => {
            AOS.refreshHard();
          }
        );
      });
    }

    if (prevState.service !== this.state.service) {
      AOS.refresh();
    }
  }
    render()
    {
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="page-wrapper">
                <Header/> 
                 <Helmet>
                    <title>{this.state.service.title}</title>  
                    <meta name="description" content={this.state.service.short_info} />
                    <meta name="keywords" content={this.state.service.title} />
                    <meta property="og:image" content={this.state.service.image}  />
                    <link rel="canonical" href={base_url+'services/'+this.state.service.slug} />
                </Helmet>
                <PageHeader title={this.state.service.title}  banner={this.state.service.image} main_title={"Services"}/>
                <ServicesContent content={JSON.parse(localStorage.getItem("content"))} services={JSON.parse(localStorage.getItem("services"))} service={this.state.service} />  
                 <ExploreMore content={JSON.parse(localStorage.getItem("content"))}  services={this.state.service.services} service={this.state.service}   />  
                <GetInTouch content={JSON.parse(localStorage.getItem("content"))}/>
                <Footer/>
            </div>
       
        )
    }

}

export default withRouter(Services);;